import script from "./FlashcardDeck.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashcardDeck.vue?vue&type=script&setup=true&lang=js"

import "./FlashcardDeck.vue?vue&type=style&index=0&id=4c496fd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c496fd2"]])

export default __exports__